import React from 'react';
import Avatar from '../ui/Avatar';
import './Leaderboard.css';

// `leaderboard`: GET /portal/leaderboard's shape — top N plus a window
// around the current student (never the full roster). No rank-movement
// column: leaderboard_snapshots is college-wide only, with no batch
// dimension, so a truthful batch-scoped "#12 → #7" isn't available yet —
// see docs/UI_UX_ARCHITECTURE.md Phase 4 §7 for the schema that would be
// needed, rather than guessing at movement here.
const Leaderboard = ({ leaderboard }) => {
  if (!leaderboard || leaderboard.entries.length === 0) {
    return (
      <div className="z-card lb-empty">
        Rank will appear once enough assessment data is available.
      </div>
    );
  }

  return (
    <div className="lb-list">
      {leaderboard.entries.map((e, i) => (
        <React.Fragment key={e.user_id}>
          {i > 0 && e.rank - leaderboard.entries[i - 1].rank > 1 && (
            <div className="lb-gap" aria-hidden="true">···</div>
          )}
          <div className={`lb-row ${e.is_me ? 'lb-row--me' : ''}`}>
            <span className="lb-rank">#{e.rank}</span>
            <Avatar avatarId={e.avatar_id} name={e.name} size="sm" />
            <span className="lb-name">{e.name}{e.is_me ? ' (You)' : ''}</span>
            <span className="lb-level">Lv {e.level}</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Leaderboard;
